import { atom } from "recoil"

export const stripeConnectUrlState = atom<string | null>({
  key: "stripeConnectUrlState",
  default: null,
})

export const stripeUrlState = atom<{ url: string; isLoading: boolean }>({
  key: "stripeUrlState",
  default: {
    url: "",
    isLoading: false,
  },
})
